export const CONTRACTS_DEFAULTS = {
  page: 0,
  limit: 25,
  sort: "date",
  order: -1,
  showCompletedRows: true,
  date: null,
  search: undefined,
};

export const TRANSPORT_ORDERS_DEFAULTS = {
  page: 0,
  limit: 25,
  sort: "unloadingDate",
  order: -1,
  showCompletedRows: true,
  loadingDate: null,
  unloadingDate: null,
  search: undefined,
};

export const FORWARDING_ORDERS_DEFAULTS = {
  page: 0,
  limit: 25,
  sort: "date",
  order: -1,
  showCompletedRows: true,
  date: null,
  search: undefined,
};

export const DELIVERIES_DEFAULTS = {
  page: 0,
  limit: 25,
  sort: "date",
  order: -1,
  showCompletedRows: true,
  date: null,
  search: undefined,
};

export const DRIVERS_DEFAULTS = {
  page: 0,
  limit: 25,
  sort: "lastName",
  order: 1,
  search: undefined,
};

export const LOCATIONS_DEFAULTS = {
  page: 0,
  limit: 25,
  sort: "address",
  order: 1,
  search: undefined,
};

export const COMPANIES_DEFAULTS = {
  page: 0,
  limit: 25,
  sort: "name",
  order: 1,
  search: undefined,
};

export const PRODUCTS_DEFAULTS = {
  page: 0,
  limit: 25,
  sort: "name",
  order: 1,
  search: undefined,
};
